const _excluded = ["children", "className", "header", "footer", "onCloseButtonClick", "disableCloseButton", "hasTopbar", "headerClassName", "showDividers", "minWidth", "anchor"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Drawer as MuiDrawer } from '@material-ui/core';
import cn from 'classnames';
import { CloseButton } from "../CloseButton";
import styles from "./Drawer.module.scss";
import { useDrawerStyles } from "./Drawer.styles";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Drawer(props) {
  const {
      children,
      className,
      header,
      footer,
      onCloseButtonClick,
      disableCloseButton = false,
      hasTopbar,
      headerClassName,
      showDividers = true,
      minWidth = 444,
      anchor = 'right'
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const classes = useDrawerStyles();
  const testId = props['data-testid'];
  return /*#__PURE__*/_jsx(MuiDrawer, _objectSpread(_objectSpread({}, rest), {}, {
    anchor: anchor,
    className: cn({
      [classes.root]: hasTopbar
    }, className),
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.root,
      style: {
        minWidth
      },
      children: [header && /*#__PURE__*/_jsxs("div", {
        className: cn(styles.header, headerClassName, {
          [styles.noDividers]: !showDividers
        }),
        children: [/*#__PURE__*/_jsx("div", {
          className: styles.headerContent,
          children: header
        }), onCloseButtonClick && /*#__PURE__*/_jsx(CloseButton, {
          "data-testid": testId && "".concat(testId, "-close-button"),
          size: "small",
          onClick: onCloseButtonClick,
          disabled: disableCloseButton
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: styles.content,
        children: children
      }), footer && /*#__PURE__*/_jsx("div", {
        className: cn(styles.footer, {
          [styles.noDividers]: !showDividers
        }),
        children: footer
      })]
    })
  }));
}